import React, { useCallback, useState } from 'react'
import clsx from 'classnames'
import { useObject } from 'src/hooks/useObject'
import { ShadowInput } from 'components/FormElements/ShadowInput/ShadowInput'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { StatusModal } from 'components/Utility/StatusModal/StatusModal'
import formStyles from './RecoveryForm.module.scss'
import styles from '../Form.module.scss'

const MIN_PASSWORD_LENGTH = 6

type NewPasswordFormProps = {
  onSubmit: (form: { password: string }) => void,
}

/** Recovery step 3: the new password, typed twice */
export const NewPasswordForm: React.FC<NewPasswordFormProps> = ({ onSubmit }) => {
  const [formError, setFormError] = useState<string | null>(null)
  const [formData, setFormField] = useObject({ password: '', passwordConfirm: '' })

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault()
    if (formData.password.length < MIN_PASSWORD_LENGTH) {
      setFormError(`Пароль должен содержать минимум ${MIN_PASSWORD_LENGTH} символов`)
      return
    }
    if (formData.password !== formData.passwordConfirm) {
      setFormError('Пароли не совпадают')
      return
    }
    onSubmit({ password: formData.password })
  }, [formData, onSubmit])

  const dismissError = useCallback(() => setFormError(null), [])

  return (
    <form noValidate onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.fields}>
        {([['password', 'Новый пароль'], ['passwordConfirm', 'Повторите пароль']] as const).map(([field, title]) => (
          <ShadowInput
            key={field}
            className={styles.field}
            type={'password'}
            value={formData[field]}
            onChange={(value) => setFormField(field, value)}
            shadowColor={'satin'}
            placeholder={title}
            autoComplete={'new-password'}
          />
        ))}
      </div>
      <div className={styles.actions}>
        <AppButton type={'submit'} className={clsx([styles.action, formStyles.action])}>
          Изменить пароль
        </AppButton>
      </div>
      <StatusModal
        status={'error'}
        modalText={formError}
        buttonText={'ОК'}
        onClose={dismissError}
        onButtonClick={dismissError}
        isOpen={formError !== null}
      />
    </form>
  )
}
